<template>
	<nuxt-link :to="url">
		<b-button
			variant="primary"
			size="lg"
			class="glow-button d-flex align-items-center"
		>
			<span>
				<slot />
			</span>
			<ArrowNextCircle />
		</b-button>
	</nuxt-link>
</template>
<script>
import ArrowNextCircle from '~/static/svg/arrow-next-circle.vue';

export default {
	name: 'GlowButton',
	components: { ArrowNextCircle },
	props: {
		url: {
			type: String,
			default: '',
		},
	},
};
</script>

<style scoped lang="scss">
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

.glow-button {
	border-radius: 2.5rem;
	gap: 1rem;

	box-shadow: 0 0 27px #0000FF;

	svg {
		width: 1rem;
		height: auto;
	}
}
</style>
